// Rarely Young department pages: live catalog as one mixed grid with collection
// filters. Products come from assets/ry-products.js
// (RarelyYoung.loadProducts), which maps every store product to a department.
(function () {
  var root = document.querySelector('[data-ryy-department]');
  if (!root || !window.RarelyYoung) return;
  var TYPE = root.getAttribute('data-ryy-type');
  var DEPARTMENT = root.getAttribute('data-ryy-department');
  var COLLECTIONS = JSON.parse(document.getElementById('ryyCollections').textContent);
  var catalog = document.getElementById('ryyCatalog');
  var filtersEl = document.getElementById('ryyFilters');
  var context = document.getElementById('ryyContext');
  var active = null;

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(n) { return '$' + (Number.isInteger(n) ? n : n.toFixed(2)); }

  // Same collection rules the earlier Rarely Young pages used; shared by every department.
  function collectionIds(p) {
    var maker = String(p.maker || '').toLowerCase();
    var text = (p.name + ' ' + p.full).toLowerCase();
    var ids = {};
    function inMaker() { for (var i = 0; i < arguments.length; i++) if (arguments[i].toLowerCase() === maker) return true; return false; }
    function has() { for (var i = 0; i < arguments.length; i++) if (text.indexOf(arguments[i].toLowerCase()) !== -1) return true; return false; }
    if (inMaker('Fagus', 'Mader', 'Sabo Concept', 'PlanToys', 'QToys', 'Grapat', 'CUBORO', 'Abel', 'Just Blocks', 'Tender Leaf Toys', 'TWW Wholesale', 'Moover', 'ComfyCubs') || maker === 'wobbel' || (maker === 'brooklyn neutral' && has('wooden'))) ids['wooden-toys'] = 1;
    if (maker === 'senger naturwelt' || (maker === 'viverano organics' && has('stuffed', 'animal', 'lion', 'dino'))) ids['soft-friends'] = 1;
    if (inMaker('PlanToys', 'Tender Leaf Toys') || (maker === 'qtoys' && has('ship', 'stable', 'barn')) || (maker === 'sabo concept' && has('journey', 'kingdom', 'courtyard', 'ancient city', 'castle', 'forest', 'lighthouse', 'kitchen', 'tea set')) || (maker === 'grapat' && has('nins'))) ids['small-worlds'] = 1;
    if (inMaker('Abel', 'CUBORO', 'Just Blocks') || (maker === 'grapat' && has('woodland', 'nins')) || (maker === 'sabo concept' && has('blocks', 'rainbow', 'trees', 'forest')) || (maker === 'qtoys' && has('balls'))) ids['building-open-play'] = 1;
    if (maker === 'filana' || (maker === 'june & december' && has('press', 'herbarium'))) ids['art-making'] = 1;
    if (maker === 'banwood') ids['ride-roll'] = 1;
    if (maker === 'wobbel' || (maker === 'fitwood' && !has('canopy', 'floor cushion'))) ids['climb-move'] = 1;
    if (inMaker('Journeyman Handcraft', 'June & December', 'WeeWander', 'BeaverCraft', 'Exotac', 'NOCS Provisions', 'Olight', 'Mini Kyomo', 'PlaySTEM', 'Hey August', 'Haptic Lab') || maker === 'rarely') ids['explore-collect'] = 1;
    if (inMaker('HarperCollins', 'Penguin Random House', 'Simon & Schuster') || maker === 'toverlux') ids['books-stories'] = 1;
    if (inMaker('Crane Baby', 'Upseat', 'Comfy Cubs', 'Senger Naturwelt', 'Olive & Cradle', 'Olive and Cradle') || maker === 'viverano organics' || (maker === 'fitwood' && has('floor cushion'))) ids['nursery-comfort'] = 1;
    if (inMaker('Lorena Canals', 'Millstream Home', 'Toverlux') || (maker === 'fitwood' && has('canopy', 'cushion')) || (maker === 'crane baby' && has('play mat', 'playmat')) || maker === 'comfy cubs') ids['rooms-spaces'] = 1;
    if (inMaker('Rarely', 'Parker Homestead', 'BeaverCraft', 'Exotac', 'Journeyman Handcraft', 'WeeWander', 'Mini Kyomo', 'Hey August') || (maker === 'banwood' && has('helmet', 'protective', 'basket'))) ids['useful-things'] = 1;
    return Object.keys(ids);
  }

  // Senger geese stay Rest & Grow but also appear on Play.
  // Mobiles with a goose stay off Play (Rest & Grow only).
  function isSengerGoose(p) {
    var maker = String(p.maker || '').toLowerCase();
    var vendor = String(p.vendor || '').toLowerCase();
    if (maker.indexOf('senger') === -1 && vendor.indexOf('senger') === -1) return false;
    var blob = (String(p.handle || '') + ' ' + String(p.name || '') + ' ' + String(p.full || '')).toLowerCase();
    if (blob.indexOf('mobile') !== -1) return false;
    return blob.indexOf('goose') !== -1;
  }

  function card(p) {
    var img = p.img ? '<img src="' + esc(p.img) + '" srcset="' + esc(p.thumb) + ' 400w, ' + esc(p.img) + ' 900w" sizes="(max-width: 1023px) 45vw, 20vw" alt="' + esc(p.name) + '" loading="lazy">' : '';
    var price = '';
    if (p.price != null) {
      var range = p.priceMax > p.price ? money(p.price) + ' – ' + money(p.priceMax) : money(p.price);
      var was = p.compareAtPrice && p.compareAtPrice > p.price ? '<s>' + money(p.compareAtPrice) + '</s>' : '';
      price = '<span class="ryy-price">' + range + was + '</span>';
    }
    var url = String(p.url || '');
    url += (url.indexOf('?') === -1 ? '?' : '&') + 'from=rarely-young';
    return '<a class="ryh-card" href="' + esc(url) + '"><span class="ryh-tile">' + img + '</span><span class="ryh-card-text"><h3>' + esc(p.full) + '</h3>' + price + (p.available ? '' : '<span class="ryh-sold">Sold out</span>') + '</span></a>';
  }

  var PRODUCTS = [];

  function render() {
    var visible = active ? PRODUCTS.filter(function (p) { return p.collections.indexOf(active) !== -1; }) : PRODUCTS;
    if (!visible.length) { catalog.innerHTML = '<div class="ryy-empty">Nothing here yet.</div>'; return; }
    // Seamless mixed grid: brand A–Z, like products together, heroes before
    // add-ons, then smaller to larger. No maker headers. Home does not use this sort.
    visible = RarelyYoung.sortByBrand(visible);
    catalog.innerHTML = '<div class="ryh-grid ryy-grid"></div><div class="ryy-more" aria-hidden="true"></div>';
    var grid = catalog.querySelector('.ryh-grid'), more = catalog.querySelector('.ryy-more'), i = 0, BATCH = 24;
    function next() { grid.insertAdjacentHTML('beforeend', visible.slice(i, i + BATCH).map(card).join('')); i += BATCH; if (i >= visible.length) { more.remove(); if (io) io.disconnect(); } }
    var io = window.IntersectionObserver ? new IntersectionObserver(function (es) { if (es.some(function (e) { return e.isIntersecting; })) next(); }, { rootMargin: '900px 0px' }) : null;
    next();
    if (io && i < visible.length) io.observe(more); else while (i < visible.length) next();
    filtersEl.querySelectorAll('[data-collection]').forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-collection') === active); });
    if (active) {
      var c = COLLECTIONS.filter(function (x) { return x.id === active; })[0];
      context.querySelector('h3').textContent = c.name;
      context.querySelector('p').textContent = c.description;
      context.classList.add('is-on');
    } else {
      context.classList.remove('is-on');
    }
  }

  function select(id, scroll) {
    active = id;
    render();
    history.replaceState(null, '', id ? '#collection-' + id : '#catalog');
    if (scroll) (id ? context : document.getElementById('catalog')).scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  filtersEl.hidden = !COLLECTIONS.length;
  filtersEl.innerHTML = '<span class="ryy-filters-label">Collections</span>' + COLLECTIONS.map(function (c) {
    return '<button type="button" class="ryy-pill" data-collection="' + esc(c.id) + '">' + esc(c.name) + '</button>';
  }).join('');
  filtersEl.addEventListener('click', function (e) {
    var b = e.target.closest('[data-collection]'); if (!b) return;
    var id = b.getAttribute('data-collection');
    select(id === active ? null : id, true);
  });
  context.querySelector('button').addEventListener('click', function () { select(null, true); });

  catalog.innerHTML = '<div class="ryh-grid ryy-grid ryy-skeleton" aria-hidden="true">' + new Array(12).fill('<div class="ryh-card"><span class="ryh-tile"></span><span class="ryh-card-text"><span class="ryy-sk"></span><span class="ryy-sk ryy-sk-short"></span></span></div>').join('') + '</div>';
  RarelyYoung.loadProducts().then(function (all) {
    if (DEPARTMENT === 'All') PRODUCTS = all.slice();
    else if (TYPE === 'christmas') PRODUCTS = all.filter(function (p) { return p.christmas; });
    else PRODUCTS = all.filter(function (p) { return p.department === DEPARTMENT; });
    PRODUCTS.forEach(function (p) { p.collections = collectionIds(p); });
    if (TYPE === 'play') {
      var seen = {};
      PRODUCTS.forEach(function (p) { seen[p.handle] = 1; });
      all.forEach(function (p) {
        if (seen[p.handle] || !isSengerGoose(p)) return;
        p.collections = collectionIds(p);
        PRODUCTS.push(p);
      });
    }
    var hash = location.hash || '';
    if (hash.indexOf('#collection-') === 0 && COLLECTIONS.some(function (c) { return c.id === hash.slice(12); })) { select(hash.slice(12), false); }
    else { render(); }
  }).catch(function (err) {
    catalog.innerHTML = '<div class="ryy-empty">Could not load the collection. Please try again.</div>';
    if (window.console) console.warn('Rarely Young catalog', err);
  });
})();
